import { render } from "./Register.vue?vue&type=template&id=1365cafe&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=1365cafe&scoped=true&lang=css"

import exportComponent from "/home/projects/frontend.vendor-mailing-system.pravin/vendor-mailig-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1365cafe"]])

export default __exports__